// src/components/profile/SpinHistory.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import styles from "../../assets/styles/SpinHistory.module.css";
import SpinDetailsModal from "../profile/SpinDetailsModal";
import root from "../../assets/styles/Root.module.css";

function fmt2(n) {
   const v = Number(n ?? 0);
   return Number.isFinite(v) ? v.toFixed(2) : "0.00";
}

export default function SpinHistory({ fetchUrl = "/api/spins/my/", }) {
   const { authFetch } = useAuth();

   const [data, setData] = useState({ results: [], count: 0 });
   const [page, setPage] = useState(1);
   const [pageSize, setPageSize] = useState(10);
   const [loading, setLoading] = useState(false);
   const [tableLoading, setTableLoading] = useState(false);
   const [err, setErr] = useState("");

   // modal state
   const [open, setOpen] = useState(false);
   const [activeId, setActiveId] = useState(null);
   const [activeIsBonusSpin, setActiveIsBonusSpin] = useState(false);

   // derive base: "/api/spins/my/" -> "/api/spins/"
   const baseUrl = useMemo(() => fetchUrl.replace(/\/my\/?$/, "/"), [fetchUrl]);

   const query = useMemo(() => {
      const params = new URLSearchParams();
      params.set("page", page);
      params.set("page_size", pageSize);
      params.set("ordering", "-created_at");
      return params.toString();
   }, [page, pageSize]);

   const loadData = async (isInitialLoad = false) => {
      const setLoadingState = isInitialLoad ? setLoading : setTableLoading;
      setLoadingState(true);
      if (isInitialLoad) setErr("");

      try {
         const resp = await authFetch(`${fetchUrl}?${query}`, {
            headers: { Accept: "application/json" },
         });
         if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
         const json = await resp.json();
         const results = Array.isArray(json?.results) ? json.results : (json?.spins || []);
         const count = Number.isFinite(json?.count) ? json.count : results.length;
         setData({ results, count });
      } catch (e) {
         if (isInitialLoad) setErr("Не удалось загрузить историю круток.");
      } finally {
         setLoadingState(false);
      }
   };

   useEffect(() => {
      let alive = true;
      (async () => {
         await loadData(true);
      })();
      return () => { alive = false; };
   }, [authFetch, fetchUrl]);

   useEffect(() => {
      if (data.count > 0) { // Только если данные уже загружены
         loadData(false);
      }
   }, [page, pageSize]); // eslint-disable-line react-hooks/exhaustive-deps

   const totalPages = Math.max(1, Math.ceil((data.count || 0) / pageSize));


   const openDetails = (id, isBonusSpin = false) => {
      setActiveId(id);
      setActiveIsBonusSpin(isBonusSpin);
      setOpen(true);
   };




   return (
      <>
         <h3 style={{ marginTop: 0 }}>История круток</h3>


         <div className={styles.tableWrap}>
            {loading ? (
               <div className={styles.helper}>Загрузка…</div>
            ) : err ? (
               <div className={styles.error}>{err}</div>
            ) : (data.results || []).length === 0 ? (
               <div className={styles.helper}>Пока нет круток.</div>
            ) : (
               <div style={{ position: 'relative' }}>
                  {tableLoading && (
                     <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(255, 255, 255, 0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10
                     }}>
                        <div className={styles.helper}>Обновление...</div>
                     </div>
                  )}
                  <table className={styles.table}>
                     <thead>
                        <tr>
                           <th>ID</th>
                           <th>Когда</th>
                           <th>Кейс</th>
                           <th>Приз</th>
                           <th>Сумма, $</th>
                           <th>Действие</th>
                        </tr>
                     </thead>
                     <tbody>
                        {data.results.map(sp => {
                           const caseName =
                              sp.case_name ??
                              sp.case?.name ??
                              (typeof sp.case === "number" ? `#${sp.case}` : "—");
                           const prizeTitle = sp.prize_title ?? sp.prize?.title ?? "—";
                           const amountUsd = sp.amount_usd ?? sp.prize?.amount_usd;
                           // Проверяем, является ли это дополнительным открытием (BonusSpin)
                           const isExtraOpen = sp.is_extra_open || sp.is_bonus_spin || sp.parent_spin_id;

                           return (
                              <tr key={sp.id} style={isExtraOpen ? { backgroundColor: "#f0f8ff" } : {}}>
                                 <td>
                                    {sp.id}
                                    {isExtraOpen && (
                                       <span style={{ 
                                          marginLeft: 8, 
                                          fontSize: "0.75em", 
                                          color: "#2196F3",
                                          fontWeight: "bold"
                                       }}>
                                          🔄 ДОП
                                       </span>
                                    )}
                                 </td>
                                 <td>{sp.created_at ? new Date(sp.created_at).toLocaleString("ru-RU") : "—"}</td>
                                 <td>
                                    {caseName}
                                    {isExtraOpen && sp.parent_spin_id && (
                                       <div style={{ fontSize: "0.75em", color: "#666", marginTop: 2 }}>
                                          к крутке #{sp.parent_spin_id}
                                       </div>
                                    )}
                                 </td>
                                 <td>{prizeTitle}</td>
                                 <td>{fmt2(amountUsd)}</td>
                                 <td>
                                    <button 
                                       className={root.btnLink} 
                                       onClick={() => openDetails(sp.id, sp.is_bonus_spin)}
                                    >
                                       Подробнее
                                    </button>
                                 </td>
                              </tr>
                           );
                        })}
                     </tbody>
                  </table>
               </div>
            )}
         </div>

         {!loading && !err && data.count > pageSize && (
            <div className={styles.pagination}>
               <span>
                  Показано {(page - 1) * pageSize + 1}-{Math.min(page * pageSize, data.count)} из {data.count} записей
               </span>
               <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <button
                     className={root.btn}
                     disabled={page <= 1}
                     onClick={() => setPage(p => Math.max(1, p - 1))}
                  >
                     ← Предыдущая
                  </button>
                  <span style={{ padding: '8px 14px', background: '#fff', border: '1px solid #ddd', borderRadius: '8px' }}>
                     {page} из {totalPages}
                  </span>
                  <button
                     className={root.btn}
                     disabled={page >= totalPages}
                     onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                  >
                     Следующая →
                  </button>
               </div>
            </div>
         )}
         <SpinDetailsModal
            open={open}
            onClose={() => {
               setOpen(false);
               setActiveIsBonusSpin(false);
            }}
            spinId={activeId}
            baseUrl={activeIsBonusSpin ? "/api/cases/bonus-spins/" : baseUrl}
         />
      </>
   );
}
